module.exports = __webpack_public_path__ + "img/marketGradientB&W.3f5ba8d1.png";